module.exports = __webpack_public_path__ + "img/8.835c23ab.png";